import React from 'react'
import { Popover, Button, CircularProgress } from '@material-ui/core'
import strings from 'strings'
import NotificationRow from './NotificationRow'

/**
 * Popover shown when the bell is clicked. Lists the latest notifications,
 * shows a Mark-all-read affordance, and offers a footer link to the relevant
 * Tasks tab.
 */
const NotificationDropdown = ({
    anchorEl,
    open,
    onClose,
    items,
    unreadCount,
    loading,
    error,
    onRowClick,
    onMarkAllRead,
    onViewAll,
    onOpenSettings
}) => {
    const t = strings.CT_BELL
    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            classes={{ paper: 'nbell-dropdown-paper' }}
        >
            <div className="nbell-dropdown">
                <div className="nbell-dropdown__header">
                    <div className="nbell-dropdown__title">
                        {t.TITLE}
                        {unreadCount > 0 && <span className="nbell-dropdown__badge">{unreadCount}</span>}
                    </div>
                    <button
                        className="nbell-dropdown__mark-all"
                        disabled={unreadCount === 0}
                        onClick={onMarkAllRead}
                    >
                        {t.MARK_ALL_READ}
                    </button>
                </div>

                <div className="nbell-dropdown__list">
                    {loading && items.length === 0 ? (
                        <div className="nbell-dropdown__loading">
                            <CircularProgress size={20} style={{ color: '#7B61FF' }} />
                        </div>
                    ) : error && items.length === 0 ? (
                        <div className="nbell-dropdown__empty nbell-dropdown__error">{error}</div>
                    ) : items.length === 0 ? (
                        <div className="nbell-dropdown__empty">{t.EMPTY}</div>
                    ) : (
                        items.map(item => (
                            <NotificationRow
                                key={item.id}
                                notification={item}
                                onClick={onRowClick}
                            />
                        ))
                    )}
                </div>

                {items.length > 0 && (
                    <div className="nbell-dropdown__footer">
                        <span className="nbell-dropdown__total">
                            {t.FOOTER_TOTAL.replace('{total}', items.length)}
                        </span>
                        <Button
                            size="small"
                            onClick={onViewAll}
                            style={{ textTransform: 'none', color: '#7B61FF', fontWeight: 600 }}
                        >
                            {t.VIEW_ALL}
                        </Button>
                    </div>
                )}
                {/* Advanced monitoring only: where to pause/resume your monitoring alerts (Profile). */}
                {onOpenSettings && (
                    <div className="nbell-dropdown__settings">
                        <button type="button" className="nbell-dropdown__settings-link" onClick={onOpenSettings}>
                            {t.NOTIFICATION_SETTINGS}
                        </button>
                    </div>
                )}
            </div>
        </Popover>
    )
}

export default NotificationDropdown
